// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toggle {
  --background-checked: #FD9805;
  --handle-background-checked: #092875;
}

ion-app {
  bottom: env(safe-area-inset-bottom);
}

::ng-deep .cdk-virtual-scroll-content-wrapper {
  position: relative !important;
}

.my-custom-class {
  --background: #222;
  --spinner-color: #fff;
  color: #fff;
}

.cancel-button {
  --background: white !important;
  --color: #092875 !important;
  --background-activated: white !important;
  margin-right: 0;
  --box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,oCAAA;AACF;;AAEA;EACE,mCAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;EAEA,WAAA;AAAF;;AAGA;EACE,8BAAA;EACA,2BAAA;EACA,wCAAA;EACA,eAAA;EACA,6BAAA;AAAF","sourcesContent":["ion-toggle {\n  --background-checked: #FD9805;\n  --handle-background-checked: #092875;\n}\n\nion-app {\n  bottom: env(safe-area-inset-bottom);\n}\n\n::ng-deep .cdk-virtual-scroll-content-wrapper {\n  position: relative !important;\n}\n\n.my-custom-class {\n  --background: #222;\n  --spinner-color: #fff;\n\n  color: #fff;\n}\n\n.cancel-button {\n  --background: white !important;\n  --color: #092875 !important;\n  --background-activated: white !important;\n  margin-right: 0;\n  --box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
